import React, { PureComponent } from "react";
import styled from "styled-components";
import { Loader } from 'react-loaders';
import { getRequest, postRequest } from '../../../api/ApiService';

const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
`;

const Text1 = styled.div`
  font-family: "Mukta Vaani";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: "Mukta Vaani";
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
  align-items: flex-start;
  justify-content: flex-start;
`;

const Option = styled.button`
  display: flex;
  width: 320px;
  height: 60px;
  background: #ffffff;
  border: 1.5px solid #d5d9dd;
  border-radius: 8px;
  align-items: center;
  justify-content: center;

  font-family: "Mukta Vaani";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    color 0.3s ease-in-out;

  ${p =>
    p.isActive &&
    `
    background-color: #eff4fe;
    border: 2px solid #5c91f5;
    color: #5c91f5;
  `}

  ${p => !p.isReadOnly && `
    &:hover {
      cursor: pointer;
      background-color: #eff4fe;
      border: 2px solid #5c91f5;
      color: #5c91f5;
    }
  `}

  ${p => p.isReadOnly && !p.isActive && `
    &:hover {
      cursor: default;
      background-color: #ffffff;
      border: 1.5px solid #d5d9dd;
      color: rgba(0, 27, 59, 0.94);
    }
  `}

  ${p => p.isReadOnly && p.isActive && `
    &:hover {
      cursor: default;
      background-color: #eff4fe;
      border: 2px solid #5c91f5;
      color: #5c91f5;
    }
  `}
`;

class TriviaSingleChoice extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
      isReadOnly: false,
    };
  }

  componentDidMount() {
    const { data } = this.props;
    const { userId, questionId, triviaId } = data;

    this.props.setMode('disabled');

    this.props.setFetchData(true);
    getRequest(`${process.env.REACT_APP_API_URL}v2/trivia/triviaresponses/`)
      .then(res => {
        const answer = res.body.results.find(i => (
          i.user === userId
          && i.trivia_question === questionId
          && i.course_trivia === triviaId
        ));
        const isReadOnly = !!answer;
        const value = answer ? answer.pickedoptions[0].option_choice : null;

        if (isReadOnly) {
          this.props.setMode('basic');
        }

        this.props.setFetchData(false);
        this.setState({
          isReadOnly,
          value,
        });
      })
      .catch(err => {});
  }

  setValue = value => {
    if (this.state.value === value) {
      this.setState(
        {
          value: null
        },
        () => {
          this.prevalidate();
        }
      );
    } else {
      this.setState(
        {
          value
        },
        () => {
          this.prevalidate();
        }
      );
    }
  };

  prevalidate = () => {
    const { value } = this.state;

    if (!!value) {
      this.props.setMode("validate", this.validate);
    } else {
      this.props.setMode("disabled");
    }
  };

  validate = () => {
    const { data } = this.props;
    const { value } = this.state;
    const { userId, questionId, triviaId } = data;

    this.props.setMode('loading');
    postRequest(`${process.env.REACT_APP_API_URL}v2/trivia/triviaresponses/`)
      .send({
        user: userId,
        trivia_question: questionId,
        course_trivia: triviaId,
        pickedoptions: [{ option_choice: value, order: 1 }],
      })
      .then(res => {
        if (res.body.is_correct === 'Yes') {
          this.props.showConfetti();
        } else {
          this.props.showIncorrectMessage();
        }

        this.setState({
          isReadOnly: true,
        });

        this.props.setMode('basic');
      })
      .catch(err => {
        this.props.setMode('basic');
      });
  };

  render() {
    const { value, isReadOnly } = this.state;
    const { data, stage, isFetchData } = this.props;
    const { num, text, choices } = data;

    return isFetchData ? (
      <Wrapper>
        <Loader type="ball-scale-ripple" active />
      </Wrapper>
    ) : (
      <Wrapper>
        <Text1>Trivia: {stage === 'welcome' ? 'Warm Up' : `Round ${stage}`}</Text1>
        <Text2>
          {num}. {text}
        </Text2>
        <Options>
          {choices.map(choice => (
            <Option
              key={`option-choice-${choice.id}`}
              isActive={value === choice.id}
              onClick={() => isReadOnly ? {} : this.setValue(choice.id)}
              isReadOnly={isReadOnly}
            >
              {choice.text}
            </Option>
          ))}
        </Options>
      </Wrapper>
    );
  }
}

export default TriviaSingleChoice;



// WEBPACK FOOTER //
// ./src/components/onboarding/trivia/SingleChoice.js